// Verstaan sijainti - Kuntolantie 52, 61300 Kurikka
export const DEPOT_LOCATION = {
  lat: 62.641697,
  lng: 22.382457,
  name: 'Verstas - Kuntolantie 52, Kurikka'
} as const;

// Suomen keskipiste karttojen oletuspaikkaan
export const FINLAND_CENTER: [number, number] = [62.5, 25.5];
